import CelebrationIcon from '@mui/icons-material/Celebration';
import { Box, Typography } from '@mui/material';
import { AvailableGiftDTO, CouponGiftDTOGiftTypeEnum, CouponsV2AvailableGiftDTO } from 'probonio-shared-ui/api';
import { useTranslation } from 'react-i18next';
import NavigationButton from '../../../component/button/NavigationButton';
import { GiftMetaLines } from './GiftMetaLines';

interface Props {
  onClick: () => void;
  gift: AvailableGiftDTO | CouponsV2AvailableGiftDTO;
}

export const GiftNavButton: React.FC<Props> = ({ onClick, gift }) => {
  const { t } = useTranslation('benefitModule');

  return (
    <Box
      sx={{
        color: 'primary',
        marginTop: 1,
      }}
    >
      <NavigationButton onClick={onClick} iconRight={null} data-test-id="gift-button" iconLeft={<CelebrationIcon fontSize="large" />}>
        <Typography
          variant="h3"
          sx={{
            color: 'text.primary',
          }}
        >
          {t(gift.giftType === CouponGiftDTOGiftTypeEnum.Incentive ? 'benefit.INCENTIVES.buttonTitle' : 'benefit.GIFTS.buttonTitle')}
        </Typography>
        <Typography
          variant="body2"
          sx={{
            color: 'text.secondary',
          }}
        >
          {t(gift.giftType === CouponGiftDTOGiftTypeEnum.Incentive ? 'benefit.INCENTIVES.buttonSubtitle' : 'benefit.GIFTS.buttonSubtitle')}
        </Typography>
        <GiftMetaLines gift={gift} />
      </NavigationButton>
    </Box>
  );
};
